import { render } from "./expenses_create_edit.vue?vue&type=template&id=33b1898e&scoped=true"
import script from "./expenses_create_edit.vue?vue&type=script&lang=js"
export * from "./expenses_create_edit.vue?vue&type=script&lang=js"

import "./expenses_create_edit.vue?vue&type=style&index=0&id=33b1898e&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-33b1898e"]])

export default __exports__